import { init_sc_swipers } from './ui/swiper.js';

/**
 * Las imágenes de las cards nacen con `opacity: 0` (ver base/reset.css) y solo se
 * ven cuando JS les pone `.loaded`. Por eso hay que volver a pasar por aquí cada
 * vez que entren cards nuevas en el DOM —"cargar más" y filtros del loop—, o se
 * quedan invisibles para siempre.
 *
 * Sin la librería imagesLoaded: se apoyaba en el plugin jQuery que registra
 * wp-includes/js/imagesloaded.min.js, y en stage WP Rocket lo servía después de que
 * este módulo ya hubiera arrancado, con lo que `.imagesLoaded is not a function` y las
 * cards se quedaban invisibles. Con `img.complete` y el evento `load` no hay nada de
 * lo que depender. Igual que hacía la librería, una imagen rota no se marca: mejor
 * el hueco que el icono de imagen rota.
 *
 * @param {Element|jQuery|null} context Ámbito a revisar. Sin él, todo el documento.
 */
export function markLoopImagesLoaded(context) {
    const root = !context ? document : (context.jquery ? context[0] : context);

    if (!root) return;

    const containers = [...root.querySelectorAll('.loop-card-container')];

    if (root.matches && root.matches('.loop-card-container')) {
        containers.unshift(root);
    }

    containers.forEach((container) => {
        container.querySelectorAll('img').forEach((img) => {
            if (img.complete) {
                if (img.naturalWidth > 0) img.classList.add('loaded');
                return;
            }
            img.addEventListener('load', () => img.classList.add('loaded'), { once: true });
        });
    });
}

// Expuesta en window igual que init_sc_swipers: loop.js la llama tras cada AJAX.
window.markLoopImagesLoaded = markLoopImagesLoaded;

jQuery(function($) {

    lucide.createIcons();
    init_sc_swipers();

    markLoopImagesLoaded();
});